import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import * as CryptoJS from 'crypto-js';
import * as forge from 'node-forge';
@Injectable()
export class UserService {


    publicKey: string = `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoRuUJ/00OTIh82a1EfXu
    Qp1QfPn3bQPSjt/7h3EvYceB/bCsLgofbKQ+kvwTSz0ERNKTcSB3XUvu02VMk5YK
    bkAIchEacdYFqDDnw9nACFZJn3qyJI/SF5m7JUiaf3KS2trUh+whCHBE/TzezBx+
    I+WNrOeCUdnd0XXuTIOyay9E+E//4nUZgmJ9XY/Jjb81sq1voxV6pVy1+BEel4BQ
    sBnAxNWEx9KTlpMjuHK2aqOkCNTTv5G0yefGdWcXIGdFXOhECE9b12p3Nc4OGx5d
    /LKb7m2kSeKjj1jPnjNHVDrnrzRnEcIKmDjwAL7FequkW3OYhmP/enuvYL55GTyA
    fwIDAQAB
    -----END PUBLIC KEY-----`;

    getEventRoute = '/api/user/';
    tokenFromUI: string = "1e2f3g4c5h7a8x9q";
    tokenFromIV: any;

    constructor(private dataService: DataService) {
    };

    getLookUp(refresh: boolean) {
        return this.dataService.getData('/api/user/lookup', refresh);
    }
    getAppVersion(apptype: any, refresh: boolean) {
        return this.dataService.getData('/api/common/version/' + apptype, refresh);
    }
    logout(refresh: boolean) {
        return this.dataService.getData('/api/user/logout', refresh);
    }
    getUserLook(subdivision, refresh: boolean) {
        return this.dataService.getData('/api/user/getSubDivisionByUserList/' + subdivision, refresh);
    }

    // get(subdivisionId: number, refresh: boolean) {
    //     return this.dataService.getData('/api/user/bysubdivision/' + subdivisionId, refresh);
    // }
    get(data: any, refresh: boolean) {
        return this.dataService.getData('/api/user/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.financialYearId + '/' + data.districtId + '/' + data.blockId, refresh);
    }

    // api/user/paccsuser/{districtId}/{blockId}/{villageId}/{gramPanchayatId}

    getpaccsuser(data: any, refresh: boolean) {
        return this.dataService.getData('/api/user/paccsuser/' + data.districtId + '/' + data.blockId + '/' + data.villageId + '/' + data.gramPanchayatId, refresh)
    }
    getById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/user/' + id, refresh);
    }

    getUserForPasswordReset(searchValue: string) {
        return this.dataService.getDataWithParams('/api/user/passwordreset', { searchValue: searchValue }, true);
    }

    resetUserPassword(id: number) {
        return this.dataService.post('/api/user/passwordreset/' + id, null).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    save(result: any) {
        // result.confirmPassword = btoa(result.confirmPassword);
        // this.tokenFromIV = (Math.random() + ' ').substring(2, 10) + (Math.random() + ' ').substring(2, 10);
        // if (result.password) {
        // let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
        // let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromIV);
        // let encrypted = CryptoJS.AES.encrypt(
        //     JSON.stringify(result.password), _key, {
        //     keySize: 16,
        //     iv: _iv,
        //     mode: CryptoJS.mode.ECB,
        //     padding: CryptoJS.pad.Pkcs7
        // });
        // var encryptKeyIv = this.tokenFromIV + encrypted.toString();
        // }
        // result.password = btoa(result.password);
        if (result.password) {
            var rsa = forge.pki.publicKeyFromPem(this.publicKey);
            result.password = window.btoa(rsa.encrypt(result.password));
        }
        // result.password = btoa(encryptKeyIv);
        return this.dataService.post('/api/user', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    savePACCS(data: any) {
        return this.dataService.post('/api/user/paccsuserupdate', data)
    }

    delete(id: number, status: number) {
        return this.dataService.post('/api/user/update/' + id + '/' + status, null).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    forgotpasswordUser(user: any) {
        return this.dataService.post('/api/user/forgotpassword', user).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    changepasswordUser(user: any) {
        // this.tokenFromIV = (Math.random() + ' ').substring(2, 10) + (Math.random() + ' ').substring(2, 10);
        // if (user.newPassword) {
        //     let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
        //     let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromIV);
        //     let encrypted = CryptoJS.AES.encrypt(
        //         JSON.stringify(user.newPassword), _key, {
        //         keySize: 16,
        //         iv: _iv,
        //         mode: CryptoJS.mode.ECB,
        //         padding: CryptoJS.pad.Pkcs7
        //     });
        //     var newEncryptKeyIv = this.tokenFromIV + encrypted.toString();
        // }
        // if (user.oldPassword) {
        //     let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
        //     let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromIV);
        //     let encrypted = CryptoJS.AES.encrypt(
        //         JSON.stringify(user.oldPassword), _key, {
        //         keySize: 16,
        //         iv: _iv,
        //         mode: CryptoJS.mode.ECB,
        //         padding: CryptoJS.pad.Pkcs7
        //     });
        //     var oldEncryptKeyIv = this.tokenFromIV + encrypted.toString();
        // }
        // const request = {
        //     newPassword: btoa(user.newPassword),
        //     oldPassword: btoa(user.oldPassword),
        //     userId: user.userId
        // };
        var newEncryptPwd = "";
        var oldEncryptPwd = "";
        if (user.newPassword) {
            var rsa = forge.pki.publicKeyFromPem(this.publicKey);
            newEncryptPwd = window.btoa(rsa.encrypt(user.newPassword));
        }
        if (user.oldPassword) {
            var rsa = forge.pki.publicKeyFromPem(this.publicKey);
            oldEncryptPwd = window.btoa(rsa.encrypt(user.oldPassword));
        }
        const request = {
            newPassword: newEncryptPwd,
            oldPassword: oldEncryptPwd,
            userId: user.userId,
            captchaId: user.captchaId,
            captcha: user.captchaInput
        };
        // const request = {
        //     newPassword: btoa(newEncryptKeyIv),
        //     oldPassword: btoa(oldEncryptKeyIv),
        //     userId: user.userId
        // };
        return this.dataService.post('/api/user/changepassword', request).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }


    newpaswordUser(user: any) {
        return this.dataService.post('/api/user/newpasword', user).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    getRoll(refresh: boolean) {
        return this.dataService.getData('/api/user/role', refresh);
    }
    getUserImg(userid: any, refresh: any) {
        return this.dataService.getData('/api/user/' + userid, refresh);
    }
    getMenu(refresh: boolean) {
        return this.dataService.getData('/api/user/menu', refresh);
    }
    generateCaptcha(refresh: boolean) {
        return this.dataService.getData('/api/common/captcha', refresh);
    }
}
